<div class="epa-section" [class.variant-red]="variant === 'red'" [class.variant-green]="variant === 'green'">
  <div class="section-header" [class.is-collapsible]="collapsible" (click)="toggle()">
    <div class="section-header-left">
      <div class="section-icon-wrap">
        <grid-icon [name]="iconName" size="l"></grid-icon>
      </div>
      <div class="section-header-text">
        <h3 class="section-title">{{ title }}</h3>
        <p class="section-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <span class="toggle-arrow" *ngIf="collapsible" [class.collapsed]="!expanded">&#9660;</span>
  </div>

  <div class="section-content" *ngIf="expanded">
    <ng-content></ng-content>
  </div>
</div>
